export default __webpack_public_path__ + "static/media/hp.3cfd8b9a.jpeg";